import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Box } from "@common/components/";
import { SkuAddToListProvider } from "./SkuAddToListContext";
import Input from "./Input";
import ScanButton from "./ScanButton";
import SubmitButton from "./SubmitButton";
import ScannerDialog from "./ScannerDialog";
import List from "./List";
import SkuAddConfirmDialog from "./SkuAddConfirmDialog";

/**
 * SkuAddToList - SKU 加入清單組件
 *
 * 接收 useSkuAddToList（或 usePurchaseSkuAdd 等場景 Hook）回傳的完整結果，
 * 透過 {...skuAddProps} 傳入即可。
 */
const SkuAddToList = ({
	children,
	enabled = true,
	className = "",
	...skuAddProps
}) => {
	const inputRef = useRef(null);

	return (
		<SkuAddToListProvider
			{...skuAddProps}
			inputRef={inputRef}
			enabled={enabled}
		>
			<Box className={className}>{children}</Box>
		</SkuAddToListProvider>
	);
};

SkuAddToList.propTypes = {
	children: PropTypes.node.isRequired,
	enabled: PropTypes.bool,
	className: PropTypes.string,
	// 以下來自 useSkuAddToList
	products: PropTypes.array,
	clearProducts: PropTypes.func,
	fetchProductBySku: PropTypes.func,
	getProductKey: PropTypes.func,
	getQuantityFromProduct: PropTypes.func,
	defaultQuantity: PropTypes.number,
	handleAddProduct: PropTypes.func,
	handleQuantityChange: PropTypes.func,
	handleDeleteProduct: PropTypes.func,
	quantityEditTarget: PropTypes.object,
	handleOpenQuantityEdit: PropTypes.func,
	handleConfirmQuantity: PropTypes.func,
	handleCloseQuantityEdit: PropTypes.func,
	isAdding: PropTypes.bool,
};

SkuAddToList.Input = Input;
SkuAddToList.ScanButton = ScanButton;
SkuAddToList.SubmitButton = SubmitButton;
SkuAddToList.ScannerDialog = ScannerDialog;
SkuAddToList.List = List;
SkuAddToList.ConfirmDialog = SkuAddConfirmDialog;

export default SkuAddToList;
